import { useEffect, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, ActivityIndicator, Image, Dimensions, LayoutChangeEvent, Text } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import Canvas from '../../canvas'
import ScreenStatus from '../../home/ScreenStatus'
const MnInformationOnline = ({ navigation, route }) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        total,
        essFormKey
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const { postmnonline, loading, modetailsData, getImagePreviewUri } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState(false);
    const [signatureDataURL, setSignatureDataURL] = useState('')


    const data = {
        entityId: personalstore?.personalData?.entityId,
        essUserKey: intializestore?.initializeData?.userkey,
        essObKey: essUserOnBoardingKey,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        completeOnline: true,
        sign: signatureDataURL,
        martialStatus: values?.martialStatus?.toString(),
        claimAsDependent: values?.claimasdependent,
        haveOneJob: values?.haveonejob,
        married: values?.married,
        dependents: values?.dependents,
        filingStatusHead: values?.filingstatusHead,
        minnesotaAllowances: total?.toString(),
        additionalWithholding: values?.additionalwithholding,
        minnesotaExemptions: values?.minnesotaexemptions?.toString(),
        stateOfDomicle: values?.stateofdomicle,
        reservationName: values?.reservationname,
        cdibnumber: values?.cdibnumber,
        total: total?.toString(),
        Section: values?.selectingSection?.toString()
    }


    const handlesubmit = async () => {
        const response: any = await postmnonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    const [imageUri, setImageUri] = useState(null);
    const [error, setError] = useState("")

    useEffect(() => {
        const getImage = async () => {
            try {

                setError(null);

                const data = await getImagePreviewUri(
                    essUserOnBoardingFormKey,
                    essUserOnBoardingKey
                );
                // console.log("online", data)

                if (!data) {
                    setError("Something went wrong");
                    throw new Error("No image data received");
                }

                const blob = new Blob([data], { type: 'image/png' });
                const url = URL.createObjectURL(blob);

                setImageUri(url);
            } catch (err) {
                console.error("Image fetch error:", err);
                setError(err.message || "Something went wrong");
            }
        };

        getImage();
    }, [essUserOnBoardingFormKey, essUserOnBoardingKey]);

    const [containerWidth, setContainerWidth] = useState(0);
    const [imageRatio, setImageRatio] = useState(0);

    // ✅ Fetch image dimensions as soon as imageUri is available
    useEffect(() => {
        if (imageUri) {
            Image.getSize(
                imageUri,
                (imgWidth, imgHeight) => {
                    setImageRatio(imgHeight / imgWidth);
                },
                (error) => {
                    console.log('Image.getSize error:', error);
                    setImageRatio(1.414); // A4 fallback
                    setError("Something went wrong");
                }
            );
        }
    }, [imageUri]);

    // ✅ Capture container width on layout
    const handleContainerLayout = (event: LayoutChangeEvent) => {
        const width = event.nativeEvent.layout.width;
        if (width > 0) {
            setContainerWidth(width);
        }
    };

    // ✅ Compute final height only when both values are ready
    const imageHeight = containerWidth > 0 && imageRatio > 0
        ? containerWidth * imageRatio
        : 0;
    if (error) return <ScreenStatus message={error} />
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MN Withholding Taxation'}
                    />
                </View>
            </View>

            <ScrollView
                bounces={false}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 30 }}

            >
                <Card
                    style={{
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '11px',
                        padding: 0,
                        margin: 0,
                        overflow: 'hidden',
                    }}
                >
                    <View
                        style={{ width: '100%' }}
                        onLayout={handleContainerLayout}
                    >
                        {imageHeight > 0 ? (
                            <>
                                <Image
                                    source={{ uri: imageUri }}
                                    style={{
                                        width: containerWidth,
                                        height: imageHeight,
                                    }}
                                    resizeMode="contain"
                                />

                                <View style={{ width: 350, height: 150, margin: 15, marginBottom: 80 }}>
                                    <Text style={{ padding: 2, marginLeft: 10 }}>
                                        {'Signature Of Employee:'}{' '}
                                    </Text>
                                    <Canvas
                                        setSignatureDataURL={setSignatureDataURL}
                                        setHasDrawn={setHasDrawn}
                                        hasDrawn={hasDrawn}
                                    />
                                </View>

                            </>
                        ) : (
                            <ActivityIndicator style={{ marginVertical: 40 }} />
                        )}
                    </View>

                </Card>

                {loading ? (
                    <ActivityIndicator style={{ marginTop: 20 }} />
                ) : (
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingHorizontal: 16,
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() =>
                                navigation.navigate('MnInformationForm', {
                                    essUserOnBoardingFormKey,
                                    essUserOnBoardingKey,
                                    values,
                                    mode: "online"
                                })
                            }
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>
                )}
            </ScrollView>
        </>

    )
}

export default MnInformationOnline
